export default __webpack_public_path__ + "static/media/Group 3185@2x.7b15e3eb.png";